import request from '@/api/request'
/**
 * 获取城市列表(本地生活)
 */
export function getCityList(data) {
    return request({
        url: '/manager/Life/getCityList',
        method: 'post',
        data
    })
  }
  /**
   * 获取分类(本地生活)
   */
  export function getCateList(data) {
    return request({
        url: '/manager/Life/getCateList',
        method: 'post',
        data
    })
  }
  /**
   * 获取品牌(本地生活)
   */
  export function getBrandList(data) {
    return request({
        url: '/manager/Life/getBrandList',
        method: 'post',
        data
    })
  }
  /* 
  * 获取商品信息
  */
 export function getGoodsList(data) {
     return request({
         url: '/manager/Life/getGoodsList',
         method: 'post',
         data
     })
 }
/**
 * 获取商品信息
 */
export function getGoodsInfo(data) {
    return request({
        url: '/manager/Life/getGoodsInfo',
        method: 'post',
        data
    })
}
/**
 * 获取商品明细（规格）
 */
export function getGoodsDetail(data) {
    return request({
        url: '/manager/Life/getGoodsDetail',
        method: 'post',
        data
    })
}
/**
 * 获取商品运费
 */
export function getFreight(data) {
    return request({
        url: '/manager/Life/getFreight',
        method: 'post',
        data
    })
}
/**
 * 订单
 */
export function confirmOrder(data) {
    return request({
        url: '/manager/Life/confirmOrder',
        method: 'post',
        data
    })
}
/**
 * 订单确认
 */
export function submitOrder(data) {
    return request({
        url: '/manager/Life/submitOrder',
        method: 'post',
        data
    })
}